export default __webpack_public_path__ + "static/media/bench-window-back.75a105a6.webp";